"use strict";
import Login from '@/vue/apps/auth/wkl.vue'
import Vue from 'vue'
new Vue({
  el: '#login',
  template: '<Login ></Login>',
  components: { Login: Login },
})



// WEBPACK FOOTER //
// ./resources/mhg/js/auth/wkl.js